<template>
  <div v-show="$store.state.currentUrlX.indexOf('/500') == -1">
    <footer class="footer d-flex flex-column justify-content-center">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <div class="d-flex contracts-box">
          <a
            :href="
              'https://' +
              $store.state.defaultDomainX +
              '/' +
              $store.state.langCodeX +
              '/other/corporateterms'
            "
            >{{ $store.getters.getWordLocale('txt_kurumsal_sartlar') }}</a
          >
          <a
            :href="
              'https://' +
              $store.state.defaultDomainX +
              '/' +
              $store.state.langCodeX +
              '/other/privacypolicy'
            "
            >{{ $store.getters.getWordLocale('txt_gizlilik_politikasi') }}</a
          >
          <a
            :href="
              'https://' +
              $store.state.defaultDomainX +
              '/' +
              $store.state.langCodeX +
              '/other/legalnotice'
            "
            >{{ $store.getters.getWordLocale('txt_yasal_uyari') }}</a
          >
        </div>
        <span>{{ new Date().getFullYear() }} © ForieNetwork All Rights Reserved.</span>
        <div class="footer-social">
          <a
            :href="
              $store.state.domainSystemX == 1
                ? 'https://www.facebook.com/foriecom/'
                : 'https://www.facebook.com/ihracatcomtr'
            "
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
            >
              <path
                d="M16.6017 8.04902C16.6017 3.60302 13.0197 -0.000976562 8.6017 -0.000976562C4.1817 2.34375e-05 0.599701 3.60302 0.599701 8.05002C0.599701 12.067 3.5257 15.397 7.3497 16.001V10.376H5.3197V8.05002H7.3517V6.27502C7.3517 4.25802 8.5467 3.14402 10.3737 3.14402C11.2497 3.14402 12.1647 3.30102 12.1647 3.30102V5.28102H11.1557C10.1627 5.28102 9.8527 5.90202 9.8527 6.53902V8.04902H12.0707L11.7167 10.375H9.8517V16C13.6757 15.396 16.6017 12.066 16.6017 8.04902Z"
                fill="var(--m3--sys--light--primary)"
              /></svg
          ></a>

          <a
            :href="
              $store.state.domainSystemX == 1
                ? 'https://www.youtube.com/channel/UCPxOcwZem85tvKilUBdyhrQ'
                : 'https://www.youtube.com/c/TurkishExporterb2b'
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="12"
              viewBox="0 0 17 12"
              fill="none"
            >
              <path
                d="M8.65221 0.380493H8.74121C9.56321 0.383493 13.7282 0.413493 14.8512 0.715493C15.1907 0.807662 15.5001 0.987316 15.7484 1.2365C15.9967 1.48569 16.1752 1.79568 16.2662 2.13549C16.3672 2.51549 16.4382 3.01849 16.4862 3.53749L16.4962 3.64149L16.5182 3.90149L16.5262 4.00549C16.5912 4.91949 16.5992 5.77549 16.6002 5.96249V6.03749C16.5992 6.23149 16.5902 7.14549 16.5182 8.09749L16.5102 8.20249L16.5012 8.30649C16.4512 8.87849 16.3772 9.44649 16.2662 9.86449C16.1755 10.2044 15.997 10.5146 15.7487 10.7638C15.5003 11.013 15.1908 11.1926 14.8512 11.2845C13.6912 11.5965 9.28221 11.6185 8.67121 11.6195H8.52921C8.22021 11.6195 6.94221 11.6135 5.60221 11.5675L5.43221 11.5615L5.34521 11.5575L5.17421 11.5505L5.00321 11.5435C3.89321 11.4945 2.83621 11.4155 2.34921 11.2835C2.0097 11.1917 1.70028 11.0123 1.45194 10.7632C1.2036 10.5142 1.02506 10.2043 0.934212 9.86449C0.823212 9.44749 0.749212 8.87849 0.699212 8.30649L0.691212 8.20149L0.683212 8.09749C0.633859 7.41989 0.606511 6.74087 0.601212 6.06149L0.601212 5.93849C0.603212 5.72349 0.611212 4.98049 0.665212 4.16049L0.672212 4.05749L0.675212 4.00549L0.683212 3.90149L0.705212 3.64149L0.715212 3.53749C0.763212 3.01849 0.834212 2.51449 0.935212 2.13549C1.02591 1.79554 1.20437 1.4854 1.45272 1.23618C1.70108 0.986947 2.01058 0.807386 2.35021 0.715493C2.83721 0.585493 3.89421 0.505493 5.00421 0.455493L5.17421 0.448493L5.34621 0.442493L5.43221 0.439493L5.60321 0.432493C6.55492 0.401868 7.50702 0.384866 8.45921 0.381493H8.65221V0.380493ZM7.00121 3.59049V8.40849L11.1582 6.00049L7.00121 3.59049Z"
                fill="var(--m3--sys--light--primary)"
              />
            </svg>
          </a>

          <a
            :href="
              $store.state.domainSystemX == 1
                ? 'https://www.linkedin.com/company/forie/'
                : 'https://www.linkedin.com/company/turkishexportercomtr/mycompany/'
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
            >
              <path
                d="M0.600708 1.146C0.600708 0.513 1.12671 0 1.77571 0H15.4257C16.0747 0 16.6007 0.513 16.6007 1.146V14.854C16.6007 15.487 16.0747 16 15.4257 16H1.77571C1.12671 16 0.600708 15.487 0.600708 14.854V1.146ZM5.54371 13.394V6.169H3.14271V13.394H5.54371ZM4.34371 5.182C5.18071 5.182 5.70171 4.628 5.70171 3.934C5.68671 3.225 5.18171 2.686 4.35971 2.686C3.53771 2.686 3.00071 3.226 3.00071 3.934C3.00071 4.628 3.52171 5.182 4.32771 5.182H4.34371ZM9.25171 13.394V9.359C9.25171 9.143 9.26771 8.927 9.33171 8.773C9.50471 8.342 9.89971 7.895 10.5637 7.895C11.4327 7.895 11.7797 8.557 11.7797 9.529V13.394H14.1807V9.25C14.1807 7.03 12.9967 5.998 11.4167 5.998C10.1427 5.998 9.57171 6.698 9.25171 7.191V7.216H9.23571C9.24102 7.20765 9.24635 7.19932 9.25171 7.191V6.169H6.85171C6.88171 6.847 6.85171 13.394 6.85171 13.394H9.25171Z"
                fill="var(--m3--sys--light--primary)"
              />
            </svg>
          </a>

          <a
            :href="
              $store.state.domainSystemX == 1
                ? 'https://wa.me/905327772840'
                : 'https://wa.me/905335953512'
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
            >
              <path
                d="M14.2377 2.32605C13.5042 1.58573 12.6306 0.998793 11.668 0.599454C10.7054 0.200115 9.67288 -0.00364427 8.6307 4.93305e-05C4.2637 4.93305e-05 0.704703 3.55805 0.700703 7.92605C0.700703 9.32505 1.0667 10.686 1.7577 11.891L0.636703 16L4.8407 14.898C6.00371 15.531 7.30663 15.8627 8.6307 15.863H8.6347C13.0027 15.863 16.5607 12.305 16.5647 7.93305C16.5657 6.89109 16.3605 5.85924 15.961 4.89693C15.5614 3.93462 14.9754 3.06088 14.2367 2.32605H14.2377ZM8.6307 14.521C7.4497 14.5214 6.29041 14.2036 5.2747 13.601L5.0347 13.457L2.5407 14.111L3.2067 11.6781L3.0507 11.427C2.39051 10.3774 2.04135 9.16208 2.0437 7.92205C2.0437 4.29605 5.0007 1.33805 8.6347 1.33805C9.50044 1.3365 10.3579 1.50632 11.1577 1.83774C11.9575 2.16916 12.6838 2.65561 13.2947 3.26905C13.9077 3.8801 14.3937 4.60647 14.7246 5.40628C15.0555 6.20609 15.2248 7.06349 15.2227 7.92905C15.2187 11.568 12.2617 14.521 8.6307 14.521ZM12.2457 9.58705C12.0487 9.48805 11.0757 9.00905 10.8927 8.94105C10.7107 8.87605 10.5777 8.84205 10.4477 9.04005C10.3147 9.23705 9.9347 9.68605 9.8207 9.81505C9.7067 9.94805 9.5887 9.96305 9.3907 9.86505C9.1937 9.76505 8.5547 9.55705 7.7987 8.88005C7.2087 8.35505 6.8137 7.70505 6.6957 7.50805C6.5817 7.31005 6.6847 7.20405 6.7837 7.10505C6.8707 7.01705 6.9807 6.87305 7.0797 6.75905C7.1797 6.64505 7.2127 6.56105 7.2777 6.42905C7.3427 6.29505 7.3117 6.18105 7.2627 6.08205C7.2127 5.98305 6.8177 5.00605 6.6507 4.61205C6.4907 4.22305 6.3277 4.27705 6.2057 4.27205C6.0917 4.26505 5.9587 4.26505 5.8257 4.26505C5.72527 4.26755 5.62643 4.29078 5.5354 4.33328C5.44436 4.37579 5.3631 4.43665 5.2967 4.51205C5.1147 4.71005 4.6057 5.18905 4.6057 6.16605C4.6057 7.14305 5.3157 8.08205 5.4157 8.21505C5.5137 8.34805 6.8097 10.347 8.7987 11.207C9.2687 11.412 9.6387 11.533 9.9277 11.625C10.4027 11.7771 10.8317 11.754 11.1737 11.705C11.5537 11.647 12.3447 11.225 12.5117 10.762C12.6757 10.298 12.6757 9.90205 12.6257 9.81905C12.5767 9.73505 12.4437 9.68605 12.2457 9.58705Z"
                fill="var(--m3--sys--light--primary)"
              />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>
